import React from 'react';
import { Download } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import api from '../../lib/api';

const MODES = [
  {
    mode: 'consolidated',
    title: 'Single consolidated sheet',
    desc: 'One “All Sources” sheet with a Source column listing every row across all sources.',
    testId: 'download-mode-consolidated',
  },
  {
    mode: 'per_source',
    title: 'One tab per source',
    desc: 'A separate sheet for each source — easy to review source-by-source.',
    testId: 'download-mode-per-source',
  },
  {
    mode: 'both',
    title: 'Both (consolidated + per source)',
    desc: 'Starts with a consolidated sheet, then one sheet per source. The full picture.',
    testId: 'download-mode-both',
  },
];

const AllSourcesDownloadDialog = ({ open, onOpenChange, snapshot }) => {
  const snapId = snapshot?.id;
  const snapDate = snapshot?.date;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="all-sources-download-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading tracking-tight">Download All Sources · {snapshot?.label || ''}</DialogTitle>
          <DialogDescription>
            Choose how you want the workbook to be structured.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          {MODES.map((opt) => (
            <button
              key={opt.mode}
              onClick={() => {
                const a = document.createElement('a');
                a.href = api.excelAllSourcesUrl(snapId, opt.mode);
                a.download = `all-sources-${opt.mode}_${snapDate || snapId}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                onOpenChange(false);
              }}
              data-testid={opt.testId}
              className="w-full text-left border border-border bg-white hover:border-[hsl(var(--primary))] hover:bg-[#F1F6F2] transition-colors p-4 flex items-start gap-3"
            >
              <Download size={16} className="text-[hsl(var(--primary))] mt-0.5 shrink-0" />
              <div>
                <div className="font-heading font-semibold text-[14px] text-[#1A3626]">{opt.title}</div>
                <div className="text-[12px] text-[#575757] mt-0.5">{opt.desc}</div>
              </div>
            </button>
          ))}
        </div>
        <DialogFooter>
          <button className="btn-secondary" onClick={() => onOpenChange(false)} data-testid="all-sources-download-cancel">Cancel</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AllSourcesDownloadDialog;
